import type { IconSvgObject } from './types';

const MoonLandingIcon: IconSvgObject = [
  ["path", { d: "M12 12C6.47715 12 2 16.4772 2 22H22C22 16.4772 17.5228 12 12 12Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.125 17H15M15.25 17C15.25 17.1381 15.1381 17.25 15 17.25C14.8619 17.25 14.75 17.1381 14.75 17C14.75 16.8619 14.8619 16.75 15 16.75C15.1381 16.75 15.25 16.8619 15.25 17Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 22C12 20.3431 10.6569 19 9 19C7.34315 19 6 20.3431 6 22", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 12V7.5M12 7.5V2H19C19.5523 2 20 2.44772 20 3V6.5C20 7.05228 19.5523 7.5 19 7.5H12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default MoonLandingIcon;
